var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-10",attrs:{"id":"app"}},[_c('header-navigation',{attrs:{"search_visible":false},on:{"search":_vm.search}}),_vm._v(" "),(false)?_c('banner'):_vm._e(),_vm._v(" "),_c('video-box'),_vm._v(" "),_c('div',{staticClass:"container mx-auto"},[_c('tags'),_vm._v(" "),_c('video-index',{staticClass:"pt-4"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }